import themeConfig from '@configs/themeConfig'
import { createSlice } from '@reduxjs/toolkit'

const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem('menuCollapsed')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed
}

// ** Initial State
const initialState = {
  isRTL: themeConfig.layout.isRTL,
  menuCollapsed: initialMenuCollapsed(),
  menuHidden: themeConfig.layout.menu.isHidden,
  contentWidth: themeConfig.layout.contentWidth
}

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setMenuHidden(state, action) {
      state.menuHidden = action.payload
    },
    setMenuCollapsed(state, action) {
      state.menuCollapsed = action.payload
      window.localStorage.setItem('menuCollapsed', action.payload)
    },
    setContentWidth(state, action) {
      state.contentWidth = action.payload
    }
  }
})

export const { setMenuHidden, setMenuCollapsed, setContentWidth } =
  layoutSlice.actions
export default layoutSlice.reducer
